import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Input } from 'components/common/FormElements/Input'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import { TireSizeTooltip } from 'components/VehicleConfigurator'
import CustomTireSize from './CustomTireSize'
import { SIZE_NOT_LISTED_OPTION } from '../constants'

const TireEditor = ({ input: { value }, input, ...props }) =>
  <Fragment>
    <Input { ...props } input={ input } />
    <CustomTooltip small tickPosition={ 6.8 } title="Where can I find my tire size?" />
    {
      value === SIZE_NOT_LISTED_OPTION &&
        <CustomSize>
          <CustomTireSize isModal />
        </CustomSize>
    }
  </Fragment>

export default TireEditor

TireEditor.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string
  })
}

const CustomTooltip = styled(TireSizeTooltip)`
  margin-top: 5px;

  & [data-content] {
    width: 320px;
    text-align: center;
    ${Media.mobile`
      left: -16px;
      right: auto;

      &::before {
        right: auto;
        left: ${props => props.tickPosition}%;
        margin: 0 0 0 -6px;
      }

      &::after {
        right: auto;
        left: ${props => props.tickPosition}%;
        margin: 0 0 0 -15px;
      }
    `}
  }
`

const CustomSize = styled.div`
  margin: 19px 0 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid ${Theme.colors.grey};
`
